/* CustomFeature.ts */

export enum CustomFeature {
  TREATMENT = "treatment",
  MEDICATION = "medication",
}
